import { ChangeDetectorRef, Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoadService } from 'src/app/core/services/load.service';

@Component({
    selector: 'app-micro-loader',
    templateUrl: './micro-loader.component.html',
    styleUrls: ['./micro-loader.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MicroLoaderComponent implements OnInit, OnDestroy {

  private subscription?: Subscription;

  constructor(public load: LoadService, private cdr: ChangeDetectorRef) { }

  ngOnInit() {
    // No depende del change detection automatico: scripts de ads/analytics de terceros
    // pueden interferir con zone.js e impedir que Angular refresque esta vista por si solo.
    this.subscription = this.load.microChanged.subscribe(() => this.cdr.detectChanges());
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

}
